@if( showroom ) {
<ts-button
  color="secondary"
  text="Visit Showroom"
  icon-mobile="external_link"
  (clickFn)="onPreviewShowroomClick()"
  icon-button-px="1000"
  [disabled]="showroom.archived"
  [tooltip]="showroom.archived ? SHOWROOM_GUEST_LINK_ARCHIVED_TOOLTIP : ''"
></ts-button>
}
